import './Btn.css.proxy.js';
/* src/components/Btn.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	attr,
	bubble,
	children,
	claim_element,
	create_slot,
	detach,
	element,
	init,
	insert,
	listen,
	null_to_empty,
	safe_not_equal,
	transition_in,
	transition_out,
	update_slot
} from "../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let button;
	let button_class_value;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*#slots*/ ctx[4].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[3], null);

	return {
		c() {
			button = element("button");
			if (default_slot) default_slot.c();
			this.h();
		},
		l(nodes) {
			button = claim_element(nodes, "BUTTON", { type: true, class: true, label: true });
			var button_nodes = children(button);
			if (default_slot) default_slot.l(button_nodes);
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "type", /*type*/ ctx[1]);
			attr(button, "class", button_class_value = "" + (null_to_empty(/*btn*/ ctx[2]) + " svelte-5z8d89"));
			attr(button, "label", /*label*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, button, anchor);

			if (default_slot) {
				default_slot.m(button, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[5]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 8) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[3], dirty, null, null);
				}
			}

			if (!current || dirty & /*type*/ 2) {
				attr(button, "type", /*type*/ ctx[1]);
			}

			if (!current || dirty & /*btn*/ 4 && button_class_value !== (button_class_value = "" + (null_to_empty(/*btn*/ ctx[2]) + " svelte-5z8d89"))) {
				attr(button, "class", button_class_value);
			}

			if (!current || dirty & /*label*/ 1) {
				attr(button, "label", /*label*/ ctx[0]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			if (default_slot) default_slot.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { label = "" } = $$props;
	let { type = "" } = $$props;
	let { btn = "outline" } = $$props;

	function click_handler(event) {
		bubble($$self, event);
	}

	$$self.$$set = $$props => {
		if ("label" in $$props) $$invalidate(0, label = $$props.label);
		if ("type" in $$props) $$invalidate(1, type = $$props.type);
		if ("btn" in $$props) $$invalidate(2, btn = $$props.btn);
		if ("$$scope" in $$props) $$invalidate(3, $$scope = $$props.$$scope);
	};

	return [label, type, btn, $$scope, slots, click_handler];
}

class Btn extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { label: 0, type: 1, btn: 2 });
	}
}

export default Btn;
//# sourceMappingURL=Btn.js.map
